import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { SvgIconComponent } from "angular-svg-icon";
import { AvatarModule } from "primeng/avatar";
import { ButtonModule } from "primeng/button";

@Component({
    selector: "app-access-deny",
    imports: [SvgIconComponent, AvatarModule, ButtonModule],
    templateUrl: "./access-deny.component.html",
    styleUrl: "./access-deny.component.scss"
})
export class AccessDenyComponent {
	private readonly router = inject(Router);

	back() {
		this.router.navigate(["/dashboard"]);
	}
}
